var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H4C2.89543 2 2 2.89543 2 4V4.42191C2 5.4098 2.48635 6.33437 3.30041 6.89403L8.4 10.4V16.3415C8.4 17.0945 9.2008 17.5774 9.86676 17.2259L11.0668 16.5925C11.3947 16.4194 11.6 16.079 11.6 15.7082V10.4L16.6996 6.89403C17.5136 6.33437 18 5.4098 18 4.42191V4C18 2.89543 17.1046 2 16 2Z",
    fill: "#1570EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.de06c758467a09894c9be9f91b1f70f9.svg";
export { ForwardRef as ReactComponent };